var WinWidth;
$(document).ready(function () {
  WinWidth = $(window).width();
  // CheckfixSpace();
  // $('.collection-grid__wrapper .collection-filter__item #filterbutton').removeAttr('aria-expanded');
});

$(window).resize(function () {
  WinWidth = $(window).width();
  // CheckfixSpace();
});

// function CheckfixSpace() {
//   if (WinWidth >= 768) {
//     var HeaderHeight = $('.sticky-header').outerHeight();
//     $('#FilterDrawer').css('top', HeaderHeight + 'px');
//   }
// }

// document.addEventListener('DOMContentLoaded', function () {
//   const filtercount = document.querySelectorAll('.tag-list--active-tags li.tag.tag--remove');
//   const filtercounthtml = document.querySelector('#filterbutton');
//   if (filtercount.length > 0) {
//     filtercounthtml.innerHTML += `<span style="color:#DC1F26;"> (${filtercount.length} active)</span>`;
//   }
// });
